
import React from "react";
import { useNavigate } from 'react-router-dom';
import '../css/style.css';
import {SideMenuJson} from "./menu.js";
import Procurement from '../images/decidd/Procurement.png';
import { MasterContext } from "../services/MasterContext";
import Loader from "../images/impulse/gif.gif"
import ErrorPage from './ErrorPage'

function LandingCard(props) {
  const navigate = useNavigate();
  function handleClick(card_Link)  {
    if (card_Link && card_Link !== '') {
      navigate(card_Link);
    }
  };

  return (
    props.dataJSON ?
    <div className="main lpContainer">
      <article className="padingExtra">
        <div className="landpage">
          {props.dataJSON.menus.map((menu, index) => {
            return menu.item.map((data, i) => (
              data.auth&&<div className="landingbox cp" key={i} onClick={() => handleClick(data.path)}>
                <a className="full-box-link"></a>
                <div className="hc jcc">
                  <img src={Procurement} alt={data.title} />
                </div>
                <div className="policy-content">
                  <h3>{data.title}</h3>
                </div>
              </div>
            ));
          })}
        </div>
      </article>
    </div>
    : null
  );
}

function Landingpage() {
  const [menuJson,setMenuJson]=React.useState(SideMenuJson)
  const { userRole } = React.useContext(MasterContext);

  React.useEffect(() => {
    function updateAuth(menuItems, contextPermissions) {
      menuItems.forEach(item => {
        const permissions = userRole?.data?.filter(permission => permission.applicationcontext === item.roleContext);
        if (permissions && permissions.length > 0) {
          for (const permission of permissions) {
              if (permission.accessPersmission === 1) {
                item.auth = true;
              }
          }
      }
        if (item.items) {
          updateAuth(item.items, contextPermissions);
        }
      });
    }
    
    // Create a deep copy of the menu JSON to avoid mutating the original state directly
    const updatedMenuJson = JSON.parse(JSON.stringify(menuJson));
    
    // Update the auth properties based on userRole data
    updateAuth(updatedMenuJson.menus[0].item, userRole?.data);

    // Update the state with the modified menu JSON
    setMenuJson(updatedMenuJson);
  }, [userRole]);

  if(userRole?.data){
  return (
    <LandingCard dataJSON={menuJson} />
  )}else{
    return (
      <>
      {userRole?.error==="ERR_NETWORK"?<ErrorPage errorType={userRole?.error}/>:
      userRole?.error==="ServerError"?<ErrorPage errorType={userRole?.error}/>:
       <div style={{ padding: '20px', display: 'flex', justifyContent: 'center'}}>
       <div style={{overflow: 'hidden', position: 'relative', height: '500px', width:"500px" }}>
           <img src={Loader} style={{ height: '100%', width:'100%', objectPosition: 'center', objectFit: 'cover'}}/>
       </div>
       </div>
      }
      </>
            )
  }
}

export default Landingpage;
